'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
"use strict";

/*
---
description: Building detail page
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
Page.Bil = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		// new BlimpExt(document.id('description_link'), {draggable: true});

		// new Phgraph();

		// var _divtable = document.getElement('.content_main .w_divtable');

		// if(_divtable){
		// 	var _blimp_blds = _divtable.getElements('.tr');

		// 	if (_blimp_blds){
		// 		_blimp_blds.each(function(e){
		// 			var data_class = e.getProperty('data-class');

		// 			if(data_class && data_class != ''){
		// 				new BlimpExt(e, {
		// 					draggable: true,
		// 					show_veil: true,
		// 					onPostRpc: function(){
		// 						new BldBlimp(this);
		// 					}
		// 				});
		// 			}
		// 	 	});
		// 	}

		// 	var divtable = new Divtable(_divtable, {zebra_order: 'even', sortable: true});
		// 	_divtable.store('instance', divtable);

		// 	var _indicators_pc = _divtable.getElements('.indicator.price_closed'),
		// 			//pc_max_data = _divtable.getProperty('data-max-price-closed'),
		// 		pc_max_data = _divtable.getProperty('data-max-price'),
		// 			_indicators_pa = _divtable.getElements('.indicator.price_ava'),
		// 			//pa_max_data = _divtable.getProperty('data-max-price-ava'),
		// 		pa_max_data = _divtable.getProperty('data-max-price'),
		// 			_indicators_ap = _divtable.getElements('.indicator.apts'),
		// 			ap_max_data = _divtable.getProperty('data-max-apts');

		// 	var __rater = function(_elts, max_data, animate){
		// 		if(_elts && _elts.length > 0){
		// 			new Rater(_elts, 	{
		// 				'max_size': _elts[0].getSize().x,
		// 				'max_data': max_data,
		// 				'property': 'data-value',
		// 				'size': 'absolute',
		// 				'animate': animate,
		// 				'type': 'horizontal',
		// 				'duration': 1000,
		// 				'equal_speed': false,
		// 				'transition': Fx.Transitions.linear,
		// 				'calculate_even_one_element': true
		// 			});
		// 		}
		// 	};

		// 	__rater(_indicators_pc, pc_max_data, true);
		// 	__rater(_indicators_pa, pa_max_data, true);
		// 	__rater(_indicators_ap, ap_max_data, true);

		// 	var _fs = _divtable.getElement('.thead .frontend_sort'),
		// 		_ss = _divtable.getElement('.thead .serverside_sort');

		// 	if (_ss) {
		// 		_ss.show();
		// 	}
		// 	if(_fs) {
		// 		_fs.hide();
		// 	}
		// }

		// var _selects = document.getElements('.indices_header select, select#show');

		// if(_selects){
		// 	_selects.each(function(_el){
		// 		Core.add_select_switcher_support(_el);
		// 	});
		// }
	}
});
//# sourceMappingURL=bil.js.map
